import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Link,
  useHistory,
} from 'react-router-dom';
import {
  Button,
  Popover,
  PopoverBody,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { blockNavigation } from '../actions/App';

import { APIfetchUserProfileById } from '../api/User';

import UserProfileEmail from './UserProfile/Email';
import UserProfileTime from './UserProfile/Time';
import UserProfilePhone from './UserProfile/Phone';
import UserProfileTitle from './UserProfile/Title';

import {
  userIsAdmin,
  userIsManager,
} from '../helpers/Auth';
import { defaultAvatarUrl } from '../helpers/Users';

const AvatarPopover = ({
  dispatch,
  targetId,
  user,
}) => {
  const intl = useIntl();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(user);
  const [profileUrl, setProfileUrl] = useState(null);
  const targetUrl = `/profile/${profile.uuid}`;

  const toggle = (e = null) => {
    if (e) {
      e.preventDefault();
    }
    setIsOpen(!isOpen);
  };

  const openProfile = () => {
    setProfileUrl(targetUrl);
    toggle();
  };

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    APIfetchUserProfileById(user.uuid).then((response) => {
      setProfile(response.data);
    });
  }, [user.uuid, isOpen]);

  useEffect(() => {
    setTimeout(() => {
      dispatch(blockNavigation(isOpen));
    }, isOpen ? 100 : 1);

    if (profileUrl) {
      setTimeout(() => {
        setProfileUrl(null);
        history.push(targetUrl);
      }, 120);
    }
  }, [dispatch, history, isOpen, targetUrl, profileUrl]);

  return (
    <>
      <Popover
        className="avatar-popover"
        trigger="legacy"
        fade={false}
        delay={0}
        positionFixed={true}
        hideArrow={true}
        boundariesElement="scrollParent"
        isOpen={isOpen}
        target={targetId}
        toggle={toggle}
      >
        <PopoverBody>
          <a className="avatar-popover-close" href="#close" onClick={toggle}>
            <i className="far fa-xmark" />
          </a>
          <img src={profile.avatar_url || defaultAvatarUrl} alt={profile.name} />
          <div className="avatar-popover-container">
            <div className="user-profile-header">
              <UserProfileTitle profile={profile} />
            </div>
            <div className="user-profile-details">
              <ul className="user-profile-details-list">
                <UserProfileTime profile={profile} />
                {(userIsAdmin() || userIsManager()) && (
                  <UserProfileEmail profile={profile} />
                )}
                <UserProfilePhone profile={profile} />
              </ul>
            </div>
          </div>
          {(userIsAdmin() || userIsManager()) && (
            <Button
              color="primary"
              tag={Link}
              onClick={openProfile}
              to={targetUrl}
            >
              {intl.formatMessage({
                defaultMessage: 'View profile',
              })}
            </Button>
          )}
        </PopoverBody>
      </Popover>
      {(isOpen && !isOpen) && (
        <div className="avatar-popover-overlay" />
      )}
    </>
  );
};

AvatarPopover.propTypes = {
  dispatch: PropTypes.func.isRequired,
  targetId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default connect()(AvatarPopover);
